export function titleCasePt(text: string) {
    const lowerWords = ['de', 'da', 'do', 'das', 'dos', 'e', 'em', 'para', 'por', 'com'];

    const res = text
        .toLowerCase()
        .split(' ')
        .map((word, i) =>
            i !== 0 && lowerWords.includes(word)
                ? word
                : word.charAt(0).toUpperCase() + word.slice(1)
        )
        .join(' ');

    return res
        .split('-')
        .map((word, i) =>
            i !== 0 && lowerWords.includes(word)
                ? word
                : word.charAt(0).toUpperCase() + word.slice(1)
        )
        .join('-');
}
